// --- PLATE MATCHING NORMALIZATION ---
export const normalizePlate = (val) => {
  if (!val) return "";
  return val
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
};

const splitCSVLine = (line, delimiter = ",") => {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === delimiter && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }
  result.push(current);
  return result.map((v) => v.replace(/^"|"$/g, "").trim());
};

const parseItalianCurrency = (val) => {
  if (!val) return 0;
  const cleaned = val.replace(/\./g, "").replace(",", ".");
  return parseFloat(cleaned) || 0;
};

const parseItalianDateToISO = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.split(/[/-]/);
  if (parts.length !== 3) return dateStr;

  const day = parts[0].padStart(2, "0");
  const month = parts[1].padStart(2, "0");
  const year = parts[2].length === 2 ? `20${parts[2]}` : parts[2];

  return `${year}-${month}-${day}`;
};

export const parseProductionCSV = (csv) => {
  const lines = csv.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) return [];

  const headers = splitCSVLine(lines[0], ",");

  return lines.slice(1).map((line) => {
    const values = splitCSVLine(line, ",");
    const row = {};
    headers.forEach((h, i) => {
      row[h] = values[i];
    });

    const premio = parseItalianCurrency(
      row["Premio di vendita netto"] || row["Netto"],
    );
    const guarantees = parseInt(row["Numero garanzie"] || row["Garanzie"]) || 0;
    const prodotto = row["Prodotto"] || values[6] || "";
    const tipoAzione =
      row["Tipo azione"] || row["Azione"] || values[9] || "Emissione annuale";
    const codicePolizza =
      row["Codice polizza"] ||
      row["Polizza"] ||
      row["Numero polizza"] ||
      values[7] ||
      "";

    const targaVal = row["Targa"] || "";
    const rifVal = row["Riferimento"] || "";
    const riferimento = targaVal.length > 2 ? targaVal : rifVal || "";

    // STERILIZZAZIONE: Nessun calcolo qui. Solo dati grezzi.
    // I campi calcolati vengono settati a 0 e saranno popolati in calculations.ts
    return {
      collaboratore: row["Collaboratore"] || values[0] || "Sconosciuto",
      prodotto,
      rischio: row["Rischio"] || "",
      tipoAzione,
      numeroGaranzie: guarantees,
      premioNetto: premio,
      riferimento,
      dataTransazione: parseItalianDateToISO(row["Data transazione"] || ""),
      commissionRate: 0, // Demandato a calculations
      bonusFlat: 0, // Demandato a calculations
      commissionValue: 0, // Demandato a calculations
      bonusSconto: 0, // Demandato a calculations
      codicePolizza: codicePolizza.trim().toUpperCase(),
    };
  });
};

export const parseExpiryCSV = (csv) => {
  const lines = csv.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) return [];
  const headers = splitCSVLine(lines[0], ",");
  return lines.slice(1).map((line) => {
    const values = splitCSVLine(line, ",");
    const row = {};
    headers.forEach((h, i) => {
      row[h] = values[i];
    });

    const targaVal = row["Targa"] || "";
    const rifVal = row["Riferimento"] || "";
    const riferimento = rifVal.length > 1 ? rifVal : targaVal;

    return {
      collaboratore: row["Collaboratore"] || "",
      riferimento,
      scadenzaCopertura: parseItalianDateToISO(row["Scadenza copertura"] || ""),
      cliente: row["Contraente"] || row["Cliente"] || "",
      numeroPolizza: row["Codice polizza in scadenza"] || row["Polizza"] || "",
      premioLordo: parseItalianCurrency(
        row["Premio lordo annuale in scadenza"] || row["Premio lordo"] || "0",
      ),
      frazionamento: row["Frazionamento polizza"] || row["Frazionamento"] || "",
      causale: row["Causale"] || "",
    };
  });
};

export const parseLostCSV = (csv) => {
  const lines = csv.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 1) return [];

  const firstLine = lines[0];
  const delimiter = firstLine.includes(";") ? ";" : ",";

  return lines
    .map((line, index) => {
      const values = splitCSVLine(line, delimiter);
      if (values.length < 1) return null;

      const targaRaw = values[0] || "";
      const compagniaRaw = values[1] || "";

      if (index === 0) {
        const lowerTarga = targaRaw.toLowerCase();
        if (
          lowerTarga.includes("targa") ||
          lowerTarga.includes("riferimento") ||
          lowerTarga.includes("matchare")
        ) {
          return null;
        }
      }

      const normalizedTarga = normalizePlate(targaRaw);

      return {
        targa: normalizedTarga,
        ultimaCompagnia: compagniaRaw.trim() || "Sconosciuto",
      };
    })
    .filter((r) => r !== null && r.targa.length > 0);
};
